// extracted by mini-css-extract-plugin
export default {"loading_wrap":"LoadingPage_loading_wrap__nIAzD","loading_title":"LoadingPage_loading_title__9C1ts","loading_wrap_button":"LoadingPage_loading_wrap_button__V1Qb+"};